import './button.css'
import { useContext } from "react";
import AuthContext from "contexte/AuthContext";

export const LogoutButton = ({ content, variant }) => {

  const {logout} = useContext(AuthContext)


  const handleLogout = () => {
    logout();
  }

  return (
    <button className={variant === "white" && "white-button"} onClick={handleLogout}>
      {content}
    </button>
  );
};
